import { float, Fn, Loop, vec3 } from "three/tsl"

import { noise } from "./noise"

export const fbm = Fn(([x_immutable, octaves]: [any, any]) => {
  const x = x_immutable
  const v = float(0.0)
  const a = float(1)
  const normalization = float(0)
  const shift = vec3(100)

  Loop({ start: 0, end: octaves }, () => {
    normalization.addAssign(a)
    v.addAssign(a.mul(noise(x)))
    x.assign(x.mul(2.0).add(shift))
    a.mulAssign(0.5)
  })

  v.divAssign(normalization)

  return v
})
